module.exports = __webpack_public_path__ + "img/mc-r-y1.60ef7a1d.gif";